Promise.prototype.done = function (onFulfilled, onRejected) {
    this.then(onFulfilled, onRejected)
        ['catch'](function (reason) {
            // 抛出一个全局错误
            setTimeout(function () {
                throw reason;
            }, 0);
        });
};
Promise.prototype['finally'] = function (callback) {
    var  P = this.constructor;
    return this.then(
        function (value) {
            P.resolve(callback()).then(function () {
                return value;
            });
        },
        function (reason) {
            P.resolve(callback()).then(function () {
                throw reason;
            });
        }
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/core/promise.js
// module id = 197
// module chunks = 0